<div
  class="app-root"
  [class.app-root--classic]="layoutTheme() === 'classic'"
  [class.app-root--streetfood]="layoutTheme() === 'streetfood'"
  [class.app-root--cookie-banner-open]="cookieBannerOpen()"
  [attr.data-layout-theme]="layoutTheme()"
>
  <app-navbar />
  <main>
    <router-outlet />
  </main>
  <app-footer />
  <app-cookie />
</div>
